export const SAASQUATCH_COOKIE_NAME = '_saasquatch_mktg_affiliate_id';
export const RSCODE_COOKIE_NAME = 'rsCode_mktg_affiliate_id';
export const TRACK_COOKIE_NAME = 'track_cookie';
export const INCOMINGURL_COOKIE_NAME = 'incomingurl';
export const PLAN_GROUP_TOKEN_COOKIE_NAME = 'optly_var_square-one-pnp';
export const SQUARE_GEO_COOKIE_NAME = 'squareGeo';
